.sedlex-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: var(--p-font-mono);
  font-weight: 500;
  border-radius: var(--p-radius-full);
  line-height: 1;
  letter-spacing: 0.01em;
}

.sedlex-badge--sm {
  font-size: 10px;
  padding: 2px 6px;
}

.sedlex-badge--md {
  font-size: 11px;
  padding: 3px 8px;
}

.sedlex-badge--neutral {
  background: var(--bg-surface-sunken);
  color: var(--text-secondary);
  border: 1px solid var(--border-default);
}

.sedlex-badge--success {
  background: var(--success-subtle);
  color: var(--success-hover);
  border: 1px solid var(--success-hover);
}

.sedlex-badge--warning {
  background: var(--warning-subtle);
  color: var(--text-primary);
  border: 1px solid var(--warning);
}

.sedlex-badge--danger {
  background: var(--danger-subtle);
  color: var(--danger);
  border: 1px solid var(--danger);
}

.sedlex-badge--accent {
  background: var(--accent-subtle);
  color: var(--accent);
  border: 1px solid var(--accent);
}
